import * as React from 'react'
import IconButton from 'LuxKit/Button/IconButton'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import LineAngleDownIcon from 'LuxKit/Icons/line/LineAngleDownIcon'

interface Props {
  orders: Array<App.Order>
  className?: string
  isOrderDropdownOpen: boolean
  orderDropdownRef: React.RefObject<HTMLDivElement | null>
  orderButtonRef: React.RefObject<HTMLButtonElement | null>
  orderDestinationItems: Array<React.ReactElement>
  handleOrderDropdownToggle: () => void
  handleOrderDropdownClose: () => void
  handleOrderClick: (event: React.MouseEvent) => void
}

function OrderDropdown({
  orders,
  className,
  isOrderDropdownOpen,
  orderDropdownRef,
  orderButtonRef,
  orderDestinationItems,
  handleOrderDropdownToggle,
  handleOrderDropdownClose,
}: Props) {
  if (orders.length <= 1) {
    return null
  }

  return (
    <div ref={orderDropdownRef} className={className}>
      <IconButton
        kind="tertiary"
        size="small"
        children={<LineAngleDownIcon />}
        onClick={handleOrderDropdownToggle}
        ref={orderButtonRef}
      />
      <DropdownList
        size="S"
        open={isOrderDropdownOpen}
        onClose={handleOrderDropdownClose}
        triggerRef={orderButtonRef}
        anchorRef={orderDropdownRef}
      >
        {orderDestinationItems}
      </DropdownList>
    </div>
  )
}

export default OrderDropdown
